/** Situações do cliente */
export interface ClienteClassificacaoFaturamentoPositiva {
    id: number;
    nome: string;
    color: string;
}

export const clienteClassificacaoFaturamentoPositivaA: ClienteClassificacaoFaturamentoPositiva = {
    id: 1,
    nome: 'A',
    color: '#499466'
};
export const clienteClassificacaoFaturamentoPositivaB: ClienteClassificacaoFaturamentoPositiva = {
    id: 2,
    nome: 'B',
    color: '#5db980'
};
export const clienteClassificacaoFaturamentoPositivaC: ClienteClassificacaoFaturamentoPositiva = {
    id: 3,
    nome: 'C',
    color: '#69d492'
};


export const clienteClassificacoesFaturamentosPositivas: ClienteClassificacaoFaturamentoPositiva[] = [
    clienteClassificacaoFaturamentoPositivaA,
    clienteClassificacaoFaturamentoPositivaB,
    clienteClassificacaoFaturamentoPositivaC
];


/** Verifica se é a classificação de faturamento possitiva A */
export function isClienteClassificacaoFaturamentoPositivaA(classificacaoFaturamentoPositiva: number): boolean {
    return classificacaoFaturamentoPositiva === clienteClassificacaoFaturamentoPositivaA.id;
}

/** Verifica se é a classificação de faturamento possitiva B */
export function isClienteClassificacaoFaturamentoPositivaB(classificacaoFaturamentoPositiva: number): boolean {
    return classificacaoFaturamentoPositiva === clienteClassificacaoFaturamentoPositivaB.id;
}

/** Verifica se é a classificação de faturamento possitiva C */
export function isClienteClassificacaoFaturamentoPositivaC(classificacaoFaturamentoPositiva: number): boolean {
    return classificacaoFaturamentoPositiva === clienteClassificacaoFaturamentoPositivaC.id;
}
